"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMessages = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _dexieReactHooks = require("dexie-react-hooks");
var _database = require("../database");
// TODO: More rework, i18n, more messages 
var useMessages = function useMessages(tick, market, variety, filter) {
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    message = _useState2[0],
    setMessage = _useState2[1];

  // const prices = useLiveQuery(async () => {
  //   return await database.prices.toArray()
  // })

  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  (0, _react.useEffect)(function () {
    var interval = setInterval( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      var prices, type, maximum, maxDate, minimum, minDate, m, v, element, _prices$find, _prices$find2, _prices$find3, _prices$find4, _prices$find5, _prices$find6, _element, _element2, _element3, _element4, _element5, _element6;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _database.database.prices.toArray();
            case 2:
              prices = _context.sent;
              type = Math.floor(Math.random() * 5);
              _context.t0 = type;
              _context.next = _context.t0 === 0 ? 7 : _context.t0 === 1 ? 9 : _context.t0 === 2 ? 11 : _context.t0 === 3 ? 13 : 15;
              break;
            case 7:
              if (prices) {
                maximum = Math.max.apply(null, prices.map(function (e) {
                  return e.maximum;
                }));
                maxDate = (_prices$find = prices.find(function (e) {
                  return e.maximum === maximum;
                })) === null || _prices$find === void 0 ? void 0 : _prices$find.date;
                m = (_prices$find2 = prices.find(function (e) {
                  return e.maximum === maximum;
                })) === null || _prices$find2 === void 0 ? void 0 : _prices$find2.market;
                v = (_prices$find3 = prices.find(function (e) {
                  return e.maximum === maximum;
                })) === null || _prices$find3 === void 0 ? void 0 : _prices$find3.variety;
                setMessage("".concat(t('the price reached to'), " ").concat(t('maximum'), "  ").concat(t('intlCurrencyShort', {
                  val: maximum
                }), " ").concat(t('on'), " ").concat(t('intlDateShort', {
                  val: new Date(maxDate)
                }), " ").concat(t('in'), " ").concat(t(m), " ").concat(t('for'), " ").concat(t(v)));
              } else {
                setMessage("".concat(t('you are viewing'), " ").concat(t('market'), ": ").concat(t(market), ", ").concat(t('variety'), ": ").concat(t(variety)));
              }
              return _context.abrupt("break", 17);
            case 9:
              if (prices) {
                minimum = Math.min.apply(null, prices.map(function (e) {
                  return e.minimum;
                }));
                minDate = (_prices$find4 = prices.find(function (e) {
                  return e.minimum === minimum;
                })) === null || _prices$find4 === void 0 ? void 0 : _prices$find4.date;
                m = (_prices$find5 = prices.find(function (e) {
                  return e.minimum === minimum;
                })) === null || _prices$find5 === void 0 ? void 0 : _prices$find5.market;
                v = (_prices$find6 = prices.find(function (e) {
                  return e.minimum === minimum;
                })) === null || _prices$find6 === void 0 ? void 0 : _prices$find6.variety;
                setMessage("".concat(t('the price reached to'), " ").concat(t('minimum'), "  ").concat(t('intlCurrencyShort', {
                  val: minimum
                }), " ").concat(t('on'), " ").concat(t('intlDateShort', {
                  val: new Date(minDate)
                }), " ").concat(t('in'), " ").concat(t(m), " ").concat(t('for'), " ").concat(t(v)));
              } else {
                setMessage("".concat(t('you are viewing'), " ").concat(t('market'), ": ").concat(t(market), ", ").concat(t('variety'), ": ").concat(t(variety)));
              }
              return _context.abrupt("break", 17);
            case 11:
              if (prices) {
                maximum = Math.max.apply(null, prices.filter(function (e) {
                  return e.market === market && e.variety === variety;
                }).map(function (e) {
                  return e.maximum;
                }));
                element = prices.find(function (e) {
                  return e.maximum === maximum && e.market === market && e.variety === variety;
                });
                maxDate = (_element = element) === null || _element === void 0 ? void 0 : _element.date;
                m = (_element2 = element) === null || _element2 === void 0 ? void 0 : _element2.market;
                v = (_element3 = element) === null || _element3 === void 0 ? void 0 : _element3.variety;
                setMessage("".concat(t('the price reached to'), " ").concat(t('maximum'), "  ").concat(t('intlCurrencyShort', {
                  val: maximum
                }), " ").concat(t('on'), " ").concat(t('intlDateShort', {
                  val: new Date(maxDate)
                }), " ").concat(t('in'), " ").concat(t(m), " ").concat(t('for'), " ").concat(t(v)));
              } else {
                setMessage("".concat(t('you are viewing'), " ").concat(t('market'), ": ").concat(t(market), ", ").concat(t('variety'), ": ").concat(t(variety)));
              }
              return _context.abrupt("break", 17);
            case 13:
              if (prices) {
                minimum = Math.min.apply(null, prices.filter(function (e) {
                  return e.market === market && e.variety === variety;
                }).map(function (e) {
                  return e.minimum;
                }));
                element = prices.find(function (e) {
                  return e.minimum === minimum && e.market === market && e.variety === variety;
                });
                minDate = (_element4 = element) === null || _element4 === void 0 ? void 0 : _element4.date;
                m = (_element5 = element) === null || _element5 === void 0 ? void 0 : _element5.market;
                v = (_element6 = element) === null || _element6 === void 0 ? void 0 : _element6.variety;
                setMessage("".concat(t('the price reached to'), " ").concat(t('minimum'), "  ").concat(t('intlCurrencyShort', {
                  val: minimum
                }), " ").concat(t('on'), " ").concat(t('intlDateShort', {
                  val: new Date(minDate)
                }), " ").concat(t('in'), " ").concat(t(m), " ").concat(t('for'), " ").concat(t(v)));
              } else {
                setMessage("".concat(t('you are viewing'), " ").concat(t('market'), ": ").concat(t(market), ", ").concat(t('variety'), ": ").concat(t(variety)));
              }
              return _context.abrupt("break", 17);
            case 15:
              setMessage("".concat(t('you are viewing'), " ").concat(t('market'), ": ").concat(t(market), ", ").concat(t('variety'), ": ").concat(t(variety)));
              return _context.abrupt("break", 17);
            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), tick * 1000);
    return function () {
      clearInterval(interval);
    };
  }, [market, variety, filter]);
  return message;
};
exports.useMessages = useMessages;